const iOverlays = {
    html: $('html'),
    close: $('.I-js-overlay-close'),
    trigger: $('.I-js-overlay-trigger'),
    overlays: $('.I-js-overlay'),
    alertOverlays: $('.I-js-overlay.I-js-overlay--alert'),

    init() {
        this.bindEvents();

        if (this.html.hasClass('I_ie')) {
            this.calculateOverlayInnerContentForIe();
        }

        // check ob es Overlays gibt, die beim Laden der Seite angezeigt werden sollen.
        if (this.alertOverlays.length > 0) {
            this.openOverlay(this.alertOverlays);
        }
    },

    bindEvents() {
        this.close.on('click', (event) => {
            iOverlays.closeOverlay($(event.currentTarget).closest('.I-js-overlay'));
        });

        this.trigger.on('click', (event) => {
            const id = $(event.currentTarget).data('id');
            this.openOverlay($(`#${id}`));
        });

        if (this.html.hasClass('I_ie')) {
            $(window).on('resize', $.debounce(1000, () => {
                this.calculateOverlayInnerContentForIe();
            }));
        }
    },

    updateEvents() {
        this.close = $('.I-js-overlay-close');
        this.trigger = $('.I-js-overlay-trigger');
        this.bindEvents();
    },

    // Open/ Close Overlays
    closeOverlay(overlay) {
        overlay.hide();
        overlay.closest('.I-js-overlay-wrapper').hide();

        this.html.removeAttr('style');
        const scrollTop = this.html.data('scrollTop');
        window.scrollTo(0, scrollTop);

        this.unbindEscapeListener();
    },

    closeAllOverlays() {
        this.overlays.each((event) => {
            iOverlays.closeOverlay($(event.currentTarget));
        });
    },

    openOverlay(overlay) {
        overlay.css({
            display: 'inline-block',
        });
        overlay.parent().parent().show();


        const scrollTop = $(document).scrollTop();
        this.html.css({
            position: 'fixed',
            top: Number(`-${scrollTop}`),
            left: 0,
            right: 0,
        });
        this.html.data('scrollTop', scrollTop);

        this.bindEscapeListener();
    },

    // Close Overlay with ESC
    bindEscapeListener() {
        $(document).on('keyup.overlayEscape', (event) => {
            if (event.key === 'Escape') {
                iOverlays.closeAllOverlays();
            }
        });
    },

    unbindEscapeListener() {
        $(document).off('keyup.overlayEscape');
    },

    // Calculate Height on IE
    calculateOverlayInnerContentForIe() {
        this.overlays.find('.I_OBJ_overlay__content-inner').css({
            maxHeight: $(window).height() - 213,
        });
    },
};

export default iOverlays;
